import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
}

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
})
export class ImageSliderComponent implements OnInit {
  images_data: any;
  constructor(
    private matDialogRef: MatDialogRef<ImageSliderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.images_data = data;
  }

  ngOnInit() {}

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      this.nextImg();
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      this.prevImg();
    }
  }

  nextImg() {
    if (this.images_data.images.length - 1 < ++this.images_data.current_image) {
      this.images_data.current_image = 0;
    }
  }

  prevImg() {
    if (0 > --this.images_data.current_image) {
      this.images_data.current_image = this.images_data.images.length - 1;
    }
  }

  closeSlider() {
    this.matDialogRef.close();
  }
}
